import {Component} from 'react';
import axios from "axios"
import Nav from "../Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";
import {Modal} from "react-bootstrap";

let source = axios.CancelToken.source();

class Dashboard_status extends Component {
    constructor() {
        super();
        this.state = {
            objs: [],
            objsl: false,

            cushow:false,
            status:[],
            name:'',

        }
    }
    componentDidMount() {
        this.fetcheddata()
    }
    fetcheddata = () => {
        let baseurl = myconfig.get_dashboard_status;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            objs: [],
            objsl: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    sum_diredawa = () => {
        let retdata = null;
        if (this.state.objsl) {
            let dd_wfo=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            console.log(dd_wfo);
            let dd_hs=this.state.objs.diredawa.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let dd_aud=this.state.objs.diredawa.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let dd_ittlp=this.state.objs.diredawa.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let dd_wtl=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let dd_wtt=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let dd_ittop=this.state.objs.diredawa.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;
            let dd_wto=this.state.objs.diredawa.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;
            return (<>
                <div className="card card-primary  px-1 table-responsive" style={{height: "100%"}}>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-warning">
                                <h3 className>Dire Dawa</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_FOR_ORDER")} href="" className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{dd_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","HEADING_TO_STATION")} href="" className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{dd_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","ALLOCATED_UNDER_DISPATCH")} href="" className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{dd_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","IN_TRANSIT_TO_LOAD_POINT")} href="" className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{dd_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_TO_LOAD")}  href="" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{dd_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_TO_TRANSIT")}  href="" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{dd_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","IN_TRANSIT_TO_OFFLOAD_POINT")} href=""  className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{dd_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dire Dawa","WAITING_TO_OFFLOAD")}  href="" className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{dd_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }
        return <>
            {retdata}
        </>
    }
    sum_dawro = () => {
        let retdata = null;
        if (this.state.objsl) {
            let dw_wfo=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            let dw_hs=this.state.objs.dawro.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let dw_aud=this.state.objs.dawro.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let dw_ittlp=this.state.objs.dawro.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let dw_wtl=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let dw_wtt=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let dw_ittop=this.state.objs.dawro.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;
            let dw_wto=this.state.objs.dawro.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;

            return (<>
                <div className="card card-primary  px-1 table-responsive" style={{height: "100%"}}>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-primary">
                                <h3 className>Dawro</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_FOR_ORDER")} href=""  className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{dw_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","HEADING_TO_STATION")}  href="" className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{dw_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","ALLOCATED_UNDER_DISPATCH")}  href="" className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{dw_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","IN_TRANSIT_TO_LOAD_POINT")}  href="" className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{dw_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_TO_LOAD")}  href="" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{dw_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_TO_TRANSIT")}  href="" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{dw_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","IN_TRANSIT_TO_OFFLOAD_POINT")} href=""  className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{dw_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Dawro","WAITING_TO_OFFLOAD")}  href="" className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{dw_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }
        return <>
            {retdata}
        </>
    }
    sum_koka = () => {
        let retdata = null;
        if (this.state.objsl) {
            let kk_wfo=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            let kk_hs=this.state.objs.koka.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let kk_aud=this.state.objs.koka.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let kk_ittlp=this.state.objs.koka.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let kk_wtl=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let kk_wtt=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let kk_ittop=this.state.objs.koka.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;
            let kk_wto=this.state.objs.koka.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;


            return (<>
                <div className="card card-primary  px-1 table-responsive" style={{height: "100%"}}>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-fuchsia">
                                <h3 className>Koka</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_FOR_ORDER")}  href="" className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{kk_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","HEADING_TO_STATION")}  href="" className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{kk_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","ALLOCATED_UNDER_DISPATCH")}  href="" className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{kk_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","IN_TRANSIT_TO_LOAD_POINT")} href=""  className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{kk_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_TO_LOAD")}  href="" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{kk_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_TO_TRANSIT")}  href="" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{kk_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","IN_TRANSIT_TO_OFFLOAD_POINT")}  href="" className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{kk_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Koka","WAITING_TO_OFFLOAD")}  href="" className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{kk_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }
        return <>
            {retdata}
        </>
    }
    sum_other = () => {
        let retdata = null;
        if (this.state.objsl) {
            let ot_wfo=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_FOR_ORDER")
                    return v;
            }).length;
            let ot_hs=this.state.objs.other.filter(v=>{
                if(v.type=="HEADING_TO_STATION")
                    return v;
            }).length;
            let ot_aud=this.state.objs.other.filter(v=>{
                if(v.type=="ALLOCATED_UNDER_DISPATCH")
                    return v;
            }).length;
            let ot_ittlp=this.state.objs.other.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_LOAD_POINT")
                    return v;
            }).length;
            let ot_wtl=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_TO_LOAD")
                    return v;
            }).length;
            let ot_wtt=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_TO_TRANSIT")
                    return v;
            }).length;
            let ot_ittop=this.state.objs.other.filter(v=>{
                if(v.type=="IN_TRANSIT_TO_OFFLOAD_POINT")
                    return v;
            }).length;
            let ot_wto=this.state.objs.other.filter(v=>{
                if(v.type=="WAITING_TO_OFFLOAD")
                    return v;
            }).length;

            return (<>
                <div className="card card-primary  px-1 table-responsive" style={{height: "100%"}}>
                    <div className="col-12">
                        <div className="card card-widget widget-user-2 shadow-sm">
                            <div className="widget-user-header bg-gradient-green">
                                <h3 className>Other</h3>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_FOR_ORDER")} href=""  className="nav-link">
                                            WAITING_FOR_ORDER <span className="float-right badge bg-success">{ot_wfo}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","HEADING_TO_STATION")} href=""  className="nav-link">
                                            HEADING_TO_STATION <span className="float-right badge bg-info">{ot_hs}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","ALLOCATED_UNDER_DISPATCH")} href=""  className="nav-link">ALLOCATED_UNDER_DISPATCH<span
                                            className="float-right badge bg-primary">{ot_aud}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","IN_TRANSIT_TO_LOAD_POINT")} href="#" className="nav-link">
                                            IN_TRANSIT_TO_LOAD_POINT <span className="float-right badge bg-info">{ot_ittlp}</span>
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_TO_LOAD")} href="#" className="nav-link">
                                            WAITING_TO_LOAD <span className="float-right badge bg-danger">{ot_wtl}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_TO_TRANSIT")} href="#" className="nav-link">
                                            WAITING_TO_TRANSIT <span className="float-right badge bg-success">{ot_wtt}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","IN_TRANSIT_TO_OFFLOAD_POINT")} href="#"  className="nav-link">
                                            IN_TRANSIT_TO_OFFLOAD_POINT <span className="float-right badge bg-info">{ot_ittop}</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={event => this.showcu(event,"Other","WAITING_TO_OFFLOAD")} href="#"  className="nav-link">WAITING_TO_OFFLOAD<span
                                            className="float-right badge bg-primary">{ot_wto}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }
        return <>
            {retdata}
        </>
    }

    showcu = (event,name,type) => {
        event.preventDefault()
        if (this.state.objsl) {
            let status = [];
            if (name == "Dire Dawa")
                status = this.state.objs.diredawa.filter(value => {
                    if (value.type == type)
                        return value;
                })
            else if (name == "Dawro")
                status = this.state.objs.dawro.filter(value => {
                    if (value.type == type)
                        return value;
                })
            else if (name == "Koka")
                status = this.state.objs.koka.filter(value => {
                    if (value.type == type)
                        return value;
                })
            else if (name == "Other")
                status = this.state.objs.other.filter(value => {
                    if (value.type == type)
                        return value;
                })
            this.setState({
                cushow: true,
                status: status,
                name: name,
            })
        }
    }
    hidecu = () => {
        this.setState({
            cushow: false,
        })
    }
    modalcu = () => {
        let count=0;
        let tabledata=this.state.status.map(value => {
            count=count+1;
            return (
                <tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.startat}</td>
                    <td>{value.endat}</td>
                    <td>{value.avlloc}</td>
                    <td>{value.avltime}</td>
                    <td>{value.type}</td>
                </tr>
            )
        });

        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.cushow}
                onHide={this.hidecu}>
                <Modal.Header><h4>{this.state.name}</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Data's</h3>
                                </div>
                                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Plate #</th>
                                            <th>Orgin</th>
                                            <th>Destination</th>
                                            <th>Location</th>
                                            <th>Update Time</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tabledata}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <Nav type="dashboard_status"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Vehicle Status</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Status</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-md-6">
                                    {this.sum_diredawa()}
                                </div>
                                <div className="col-md-6">
                                    {this.sum_dawro()}
                                </div>
                                <div className="col-md-6">
                                    {this.sum_koka()}
                                </div>
                                <div className="col-md-6">
                                    {this.sum_other()}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalcu()}
            </>
        )
    }
}

export default Dashboard_status;
